import * as validationHelper from '../../helpers/validationHelper';
import { getValue } from './templateHelper';

/**
 * The validation message for a template control, but only once the model has opted into
 * showing errors on load (see TemplateOptions.showErrorsOnLoad). Controls without a blur
 * driven ValidatedInput use this to flag a record that loaded already incomplete.
 */
export const getLoadErrorMessage = (
  templateBuilder: any,
  path: string,
  validation?: object
): string => {
  if (!templateBuilder?.showErrorsOnLoad || !validation) {
    return '';
  }

  return (
    validationHelper.getValidationErrorMessage(
      validation,
      getValue(templateBuilder, path)
    ) || ''
  );
};
